import { render, staticRenderFns } from "./FloatBtn.vue?vue&type=template&id=05bc2596&"
import script from "./FloatBtn.vue?vue&type=script&lang=js&"
export * from "./FloatBtn.vue?vue&type=script&lang=js&"
import style0 from "./FloatBtn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports